require('../vendor/plyr/plyr.polyfilled.js');
import { gsap } from 'gsap';

const players = document.body.querySelectorAll('.videoModulePlayer');

players.forEach((item) => {
	const pl = new Plyr(item, {
		hideControls: true,
		debug: false,
		fullscreen: {
			enabled: true,
			iosNative: true
		},
		vimeo: {
			dnt: true,
			playsinline: false
		}
	});
	pl.toggleControls(false);

	const mq = window.matchMedia("(min-width: 992px)");
	if (mq.matches) {
		// only remove text on bigger than "large" screens.

		const cont = item.closest('.mediacontainer');
		const desc = cont ? cont.querySelector('.media-description') : null;
		if (desc) {
			pl.on('play', event => {
	      gsap.to(desc, {opacity: 0, pointerEvents: 'none'});
			});
			pl.on('pause', event => {
	      gsap.to(desc, {opacity: 1, pointerEvents: 'auto'});
			});
		}
	}
});
